import React from "react";
import PropTypes from "prop-types";
import { SectionHeading, EmbeddedScreen } from "./ui";
import Agreement from "../agreement";

/**
 * PS Kit — the Agreement screen, rendered inside the workspace shell.
 *
 * This section deliberately holds no state and fetches nothing. The Agreement
 * screen owns the Leegality data end to end: triggering the kit, language and
 * witness selection, references, delete, reinitiate, manual sign, the PDF
 * preview and the signatory / activity tables.
 *
 * An earlier version of this file also drew its own summary band from a second
 * call to the same endpoint. That was wrong twice over: it showed numbers that
 * could disagree with the screen below it, and GET /legality/v3/legality/
 * CREATES a CaseLegality row when none exists — so two callers racing on mount
 * left the screen reading a freshly created empty row, which is what made the
 * status blank, the signatory count 0 and the last-updated date invalid.
 * One screen, one owner.
 */
const AgreementSection = ({
    caseId,
    location,
    stageId,
    caseDetail,
    company,
    user,
    postSanctionPermission,
    permissionContext
}) => (
    <div className={"ops-ws__section"}>
        <SectionHeading
            title={"PS Kit"}
            subtitle={
                "Trigger the kit, track signatories and pull the signed output. Trigger and delete need the post-sanction group."
            }
        />
        <EmbeddedScreen flush ready={Boolean(caseDetail && caseDetail.get)}>
            <Agreement
                caseId={caseId}
                location={location}
                stageId={stageId}
                caseDetail={caseDetail}
                company={company}
                user={user}
                postSanctionPermission={postSanctionPermission}
                permissionContext={permissionContext}
            />
        </EmbeddedScreen>
    </div>
);

AgreementSection.propTypes = {
    caseId: PropTypes.number,
    location: PropTypes.object,
    stageId: PropTypes.number,
    caseDetail: PropTypes.object,
    company: PropTypes.object,
    user: PropTypes.object,
    postSanctionPermission: PropTypes.bool,
    permissionContext: PropTypes.object
};

export default AgreementSection;
